import React, { useState, useEffect } from 'react';

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return width;
}

const C = {
  bg: '#FFFFFF',
  text: '#1A1A1A',
  accent: '#00A896',
  border: '#E8E8E8',
  headerBg: 'rgba(255,255,255,0.97)',
};

function Header() {
  const isPC = useWindowWidth() > 768;
  return (
    <header style={{
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      background: C.headerBg,
      borderBottom: '1px solid #000000',
    }}>
      <div style={{
        maxWidth: 480,
        margin: '0 auto',
        padding: '14px 20px',
      }}>
        <a href="/lp02" style={{ textDecoration: 'none' }}>
          <img
            src="/images/nuntlogo.png"
            alt="Nunt"
            style={{ height: isPC ? 64 : 52, width: 'auto' }}
          />
        </a>
      </div>
    </header>
  );
}

export default function ApplyThanks() {
  return (
    <div style={{
      background: C.bg,
      minHeight: '100vh',
      fontFamily: "'Noto Sans JP', sans-serif",
    }}>
      <Header />
      <main style={{
        maxWidth: 480,
        margin: '0 auto',
        padding: '80px 20px 60px',
        textAlign: 'center',
      }}>
        {/* アイコン */}
        <div style={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          background: '#E6F7F5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 32px',
          fontSize: 32,
        }}>
          ✓
        </div>

        <h1 style={{
          fontSize: 22,
          fontWeight: 700,
          color: C.text,
          lineHeight: 1.6,
          marginBottom: 16,
        }}>
          ขอบคุณสำหรับการสมัคร
        </h1>

        <p style={{
          fontSize: 15,
          color: '#555',
          lineHeight: 1.9,
          marginBottom: 48,
        }}>
          ทีมงานจะติดต่อกลับภายใน 3 วันทำการ
        </p>

        <a
          href="/lp02"
          style={{
            display: 'inline-block',
            padding: '14px 32px',
            border: `1px solid ${C.accent}`,
            color: C.accent,
            borderRadius: 8,
            textDecoration: 'none',
            fontSize: 14,
            fontWeight: 700,
            letterSpacing: '0.04em',
          }}
        >
          กลับหน้าหลัก
        </a>
      </main>
    </div>
  );
}
